import React from "react";
import KnowledgeBackedProfileChapter from "./KnowledgeBackedProfileChapter";

// Daily Life-specific classification, grouping, and copy stay in
// dailyLifeDomain.js. Shared Profile lifecycle stays in the reusable shell.
const ProfileDailyLifeChapter = (props) => (
  <KnowledgeBackedProfileChapter {...props} presentationMode="profileItems" showGroupHeadings />
);

export default ProfileDailyLifeChapter;
